import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=068b77a8&scoped=true&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"
import style0 from "./Component.vue?vue&type=style&index=0&id=068b77a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b77a8",
  null
  
)

export default component.exports